import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AccountContext } from "../contexts/AccountContexts";



export const Pagination = ({currentPage, setCurrentPage, totalPages, top=false}) => {
    const { t } = useTranslation('common')
    const { user } = useContext(AccountContext)

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getPaginationGroup = () => {
        const pageNumbers = [];
        const maxPagesToShow = 9;
        const nSideMax = (maxPagesToShow - 5) / 2

        if (totalPages <= maxPagesToShow) {
            // Show all pages if total pages are less than or equal to maxPagesToShow
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Show ellipses if total pages exceed maxPagesToShow
            const leftLimit = Math.max(2, currentPage - nSideMax);
            // const rightLimit = totalPages - nSideMax - currentPage;
            const rightLimit = Math.min(totalPages - 2, 2 * nSideMax + leftLimit);

            // Always show the first page
            pageNumbers.push(1);

            // Show ellipses if there are hidden pages to the left
            if (leftLimit > 2) {
                pageNumbers.push("...");
            }

            let addToLeft = rightLimit < totalPages - 2 ? leftLimit : totalPages - 2 * nSideMax - 1
            // let addToRight = rightLimit >= 2 ? currentPage + nSideMax  : totalPages + 1
            let addToRight = addToLeft + 2 * nSideMax + 1 > totalPages - 1 ? totalPages - 1 : addToLeft + 2 * nSideMax + 1



            // Show page numbers between leftLimit and rightLimit
            for (let i = addToLeft; i < rightLimit + 1; i++) {
                pageNumbers.push(i);
            }

            // Show ellipses if there are hidden pages to the right
            // if (rightLimit <= totalPages - 1) {
            //   pageNumbers.push("...");
            // }
            if (rightLimit < totalPages - 2) {
                pageNumbers.push("...");
            }
            else {
                pageNumbers.push(totalPages - 1)
            }
            // Always show the last page
            pageNumbers.push(totalPages);

        }

        return pageNumbers;
    };

    return (
        <div className={`${totalPages == 0 && "hidden"} flex justify-center ${!top && "my-4 mt-auto"}`}>
            <nav>
                <ul className="pagination flex list-none">
                    {/* Previous Button */}
                    <li>
                        <button
                            className={`btn btn-sm ${currentPage === 1 ? "btn-disabled" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            {t('Previous')}
                        </button>
                    </li>

                    {/* Page Numbers with ellipses */}
                    {getPaginationGroup().map((page, index) => (
                        <li key={index} className="mx-[2px]">
                            {page === "..." ? (
                                <span className="btn btn-sm btn-disabled">...</span>
                            ) : (
                                <button
                                    className={`btn btn-sm ${currentPage === page ? "btn-active bg-primary text-white hover:bg-primary/80 border-gray-300 dark:border-gray-600" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            )}
                        </li>
                    ))}

                    {/* Next Button */}
                    <li>
                        <button
                            className={`btn btn-sm ${currentPage === totalPages ? "btn-disabled" : "bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`}
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            {t('Next')}
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}